import { render, staticRenderFns } from "./LocalLove.vue?vue&type=template&id=3620d522"
import script from "./LocalLove.vue?vue&type=script&lang=js"
export * from "./LocalLove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports